export default "__VITE_ASSET__DgkJOhPL__"